import React from "react";
import { ThemedIcon } from "./utilities";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

type EfficacyProps = {
    icon: IconProp,
    variant: ThemeVariant 
};

export type ReportEfficacyDisplayProps = {
    efficacy: number,
    size?: 
        | "xs"
        | "lg"
        | "sm"
        | "1x"
        | "2x"
        | "3x"
        | "4x"
        | "5x"
        | "6x"
        | "7x"
        | "8x"
        | "9x"
        | "10x",
    unratedLabel?: string | JSX.Element
};

export const ReportEfficacyDisplay = (
    { efficacy, size = "lg", unratedLabel = "-" } : ReportEfficacyDisplayProps
) => {
    const props : EfficacyProps | null = React.useMemo(() => {
        if (efficacy === 0) {
            return {
                icon: ['fas', 'circle-check'],
                variant: 'success'
            } as EfficacyProps;
        }
        if (efficacy === 1) {
            return {
                icon: ['fas', 'circle-xmark'],
                variant: 'warning'
            } as EfficacyProps;
        }
        if (efficacy === 2) {
            return {
                icon: ['fas', 'circle-xmark'],
                variant: 'danger'
            } as EfficacyProps;
        }
        return null;
    }, [efficacy]);  

    if (!props) {
        return typeof(unratedLabel) === 'string' ? (<span>{unratedLabel}</span>) : (<>{unratedLabel}</>)
    }

    return (
        <ThemedIcon {...props} size={size} />
    );
};

export default ReportEfficacyDisplay;